import { render } from "./BannerWeaponBowgun.vue?vue&type=template&id=ac469ba4&scoped=true"
import script from "./BannerWeaponBowgun.vue?vue&type=script&lang=js"
export * from "./BannerWeaponBowgun.vue?vue&type=script&lang=js"

import "./BannerWeaponBowgun.vue?vue&type=style&index=0&id=ac469ba4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac469ba4"]])

export default __exports__